import Vue from 'vue'
import Router from 'vue-router'
import Start from './views/Start.vue'
import PaymentSelection from '@/views/PaymentSelection'
import Callback from '@/views/Callback'
import CallbackError from '@/views/CallbackError'
import StandrohrStart from '@/views/standrohr/StandrohrStart'
import Standrohr2 from '@/views/standrohr/Standrohr2'
import Standrohr3 from '@/views/standrohr/Standrohr3'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start
    },
    {
      path: '/paymentselect',
      name: 'paymentselect',
      component: PaymentSelection
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/callbackError',
      name: 'callbackError',
      component: CallbackError
    },
    {
      path: '/standrohr',
      name: 'standrohrStart',
      component: StandrohrStart
    },
    {
      path: '/standrohr-2',
      name: 'standrohr-2',
      component: Standrohr2
    },
    {
      path: '/standrohr-3',
      name: 'standrohr-3',
      component: Standrohr3
    }
  ]
})
